import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import reducers from 'store/modules/reducers';
import middleware from './middleware';

export const INITIALIZE = 'SSDC/INITIALIZE';

const IS_PROD = process.env.NODE_ENV === 'production';

export function initialize() {
	return {
		type: INITIALIZE,
	};
}

export default function configureStore(storeConfig, initialState = {}) {
	const store = createStore(
		reducers,
		initialState,
		IS_PROD
			? applyMiddleware(...middleware(storeConfig))
			: composeWithDevTools(applyMiddleware(...middleware(storeConfig))),
	);

	return store;
}
